// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading--2U1pd","infoCard":"infoCard--1J5dd","actions":"actions--3vms1"};